import { render, staticRenderFns } from "./TocNode.vue?vue&type=template&id=1979720b&scoped=true"
import script from "./TocNode.vue?vue&type=script&lang=js"
export * from "./TocNode.vue?vue&type=script&lang=js"
import style0 from "./TocNode.vue?vue&type=style&index=0&id=1979720b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1979720b",
  null
  
)

export default component.exports